module.exports = __webpack_public_path__ + "static/img/ts_fast.cf24851.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_educloud/ts_fast.jpg
// module id = mfMd
// module chunks = 0